import { css } from "@/utils/css";
import { useState } from "react";
import { FaTimes } from "react-icons/fa";

export function Modal({ children, handleClose }: React.PropsWithChildren<{ handleClose?: () => void }>) {
    const [open, setOpen] = useState(true);

    const handleCloseInternal = () => {
        setOpen(false);
        handleClose?.();
    };

    return (
        <div className={css("modal-container")} onClick={handleCloseInternal}>
            <div className={css("modal", !open ? "closed" : "")} onClick={(e) => e.stopPropagation()}>
                <span className={css("modal-close")} onClick={handleCloseInternal}>
                    <FaTimes />
                </span>
                {children}
            </div>
        </div>
    );
}
